import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [claim, setClaim] = useState(null);
  const [loading, setLoading] = useState(true);
  const [verifyHandle, setVerifyHandle] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setClaim(data.claim);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/auth/config").then(({ data }) => setVerifyHandle(data.verify_handle)).catch(() => {});
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout");
    setUser(null);
    setClaim(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, claim, setClaim, loading, verifyHandle, refresh, logout }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
